(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotPaymentService', AngebotPaymentService);

    AngebotPaymentService.$inject = [
        '$log',
        '$injector',
        '$q',
        '$http',
        '$window',
        'lodash',
        'AppConfig',
        'BasisAngebotService',
        'FormatUtilsService',
        'MiscUtilsService',
        'DeviceUtilsService',
        'LoadingIndicatorService'
    ];
    function AngebotPaymentService($log, $injector, $q, $http, $window, _, AppConfig, BasisAngebotService, FormatUtilsService, MiscUtilsService, DeviceUtilsService, LoadingIndicatorService) {
        var that = this;

        that.initPayment = initPayment;
        that.cancelPayment = cancelPayment;
        that.statusPayment = statusPayment;
        that.redirectToPaymentProvider = redirectToPaymentProvider;
        that.closePaymentProviderPopup = closePaymentProviderPopup;
        that.getPaymentProviderOptions = getPaymentProviderOptions;
        that.getPaymentProviderRedirectUrl = getPaymentProviderRedirectUrl;
        that.getPaymentFrameModelValue = getPaymentFrameModelValue;
        that.setResultsUrls = setResultsUrls;
        that.isPayPal = isPayPal;
        that.isSofortueberweisung = isSofortueberweisung;
        that.isKreditkarte = isKreditkarte;
        that.isAsyncAlternativeBezahlmethode = isAsyncAlternativeBezahlmethode;
        that.isAlternativeBezahlmethode = isAlternativeBezahlmethode;
        function initPayment(angebotModel) {
            BasisAngebotService.mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

            if (!BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                return $q.reject('ANGEBOT_NICHT_AENDERBAR');
            }
            if (!isKreditkarte(angebotModel.angebot)) {
                return $q.reject('INKASSOART_UNGLEICH_KREDITKARTE');
            }

            setResultsUrls(angebotModel.angebot);
            if (_.get(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl') ||
                !!_.get(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentInProgress')

            ) {
                return $q.resolve({
                    angebot: angebotModel.angebot,
                    nachrichten: []
                });
            }

            _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentInProgress', true);

            return $http({
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angPaymentInit, angebotModel.tarif.tarifkuerzel),
                data: angebotModel.angebot
            }).then(function (response) {
                BasisAngebotService.mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);

                angebotModel.angebot = angular.merge({}, response.data.angebot);
                _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl', _.get(angebotModel.angebot, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl'));

                setResultsUrls(angebotModel.angebot);

                return {
                    angebot: response.data.angebot,
                    nachrichten: response.data.nachrichten
                };
            }).catch(function (error) {
                _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl', null);
                return $q.reject(error);
            }).finally(function () {
                _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentInProgress', false);
            });
        }
        function cancelPayment(angebotModel) {
            var IntegrationService = $injector.get('IntegrationService');
            BasisAngebotService.mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);
            if (!isAsyncAlternativeBezahlmethode(angebotModel.angebot)) {
                return $q.reject('INKASSOART_ZAHLUNG_NICHT_ABBRECHBAR');
            }
            if (_.get(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.cancelPaymentInProgress')) {
                return $q.resolve({
                    angebot: angebotModel.angebot,
                    nachrichten: []
                });
            }
            _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.cancelPaymentInProgress', true);

            return $http({
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angPaymentCancel, angebotModel.tarif.tarifkuerzel),
                data: angebotModel.angebot
            }).then(function (response) {
                BasisAngebotService.mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);
                angebotModel.angebot = angular.merge({}, response.data.angebot);

                return {
                    angebot: response.data.angebot,
                    nachrichten: response.data.nachrichten
                };
            }).catch(function (error) {
                var data = _.get(error, 'data') || {};
                if (MiscUtilsService.isNotEmpty(data.angebot) && (BasisAngebotService.isAntragErfolgreich(data.angebot) || BasisAngebotService.isAngebotAenderbar(data.angebot, 'ANTRAG'))) {
                    BasisAngebotService.mapServiceToFormData(data.angebot, angebotModel.formData, angebotModel.angebotInitial);
                    angebotModel.angebot = angular.merge({}, data.angebot);
                    IntegrationService.sendMessage({
                        type: 'asysAction',
                        data: {
                            type: _.includes([
                                AppConfig.ANGEBOT.status.VERTRAGSAENDERUNG,
                                AppConfig.ANGEBOT.status.VERTRAGSANLAGE
                            ], BasisAngebotService.getStatus(data.angebot)) ? 'VERTRAG_AKTUALISIERT' : 'ANGEBOT_AKTUALISIERT'
                        }
                    });
                    return {
                        angebot: data.angebot,
                        nachrichten: data.nachrichten
                    };
                } else {
                    return $q.reject(error);
                }
            }).finally(function () {
                _.set(angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.cancelPaymentInProgress', false);
            });
        }
        function statusPayment(angebotModel) {
            var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                angebotsToken = BasisAngebotService.getToken(angebotModel.angebot),
                serviceUrl = AppConfig.API.services.angStatusPayment;

            return $http({
                method: 'GET',
                url: FormatUtilsService.replace(serviceUrl, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken)
            }).then(function (response) {
                return {
                    status: response.data
                };
            }).catch(function (error) {
                $log.log(error);
            });
        }
        function redirectToPaymentProvider(angebot, redirectData) {
            var redirectURL = getPaymentProviderRedirectUrl(angebot),
                $localStorage = $injector.has('$localStorage') && $injector.get('$localStorage') || {},
                AuthenticationService = $injector.get('AuthenticationService');

            if (MiscUtilsService.isEmpty(redirectURL)) {
                $log.log('BezahldienstleisterDaten redirectURL empty');
                return;
            }
            AuthenticationService.setSession(AuthenticationService.getSession(), true);

            $localStorage.redirectData = redirectData;

            $window.onbeforeunload = null;
            $window.location.href = redirectURL;
        }
        function closePaymentProviderPopup() {
            var PaymentOverlayService = $injector.has('PaymentOverlayService') && $injector.get('PaymentOverlayService');

            if (PaymentOverlayService) {
                PaymentOverlayService.close();
            }
        }
        function getPaymentProviderOptions(angebotModel, type) {
            var provider = _.toLower(_.get(angebotModel.angebot, 'zahlungsinformationen.inkassoart')),
                angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                onClosePromise,
                url;

            if (type === 'OPEN') {
                url = MiscUtilsService.getAbsoluteUrl(AppConfig.ANGEBOT.paymentProvider.popup.urlPrefix) + 'redirect?provider=' + provider;
                onClosePromise = null;
            } else {
                url = getPaymentProviderRedirectUrl(angebotModel.angebot);
                onClosePromise = getPaymentProviderClosePromise(angebotModel);
            }

            return {
                url: url,
                provider: provider,
                options: {
                    popupName: angebotsnummer + MiscUtilsService.guid('####'),
                    visible: true
                },
                onClosePromise: onClosePromise
            };
        }
        function getPaymentProviderClosePromise(angebotModel) {
            var IntegrationService = $injector.get('IntegrationService'),
                NavigationService = $injector.get('NavigationService');

            return (function () {
                return $q(function (resolve, reject) {

                    IntegrationService.setIntegrationParams({
                        paymentState: 'FAILURE',
                        isCancelQueued: true,
                        angnummer: BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                        angtoken: BasisAngebotService.getToken(angebotModel.angebot)
                    });

                    NavigationService.goToStep('payment', {
                        force: true
                    });

                    resolve();
                });
            });
        }
        function getPaymentProviderRedirectUrl(angebot) {
            var bezahldienstleisterDaten = _.get(angebot, 'zahlungsinformationen.bezahldienstleisterDaten') || {};

            if (MiscUtilsService.isEmpty(bezahldienstleisterDaten.redirectURL)) {
                $log.error('BezahldienstleisterDaten redirectURL empty');
                return;
            }

            return bezahldienstleisterDaten.redirectURL;
        }
        function getPaymentFrameModelValue(key, model) {
            var value;

            if (MiscUtilsService.isAtLeastOneEmpty(key, model)) {
                return value;
            }

            if (key === 'CONTACT.EMAIL') {
                value = _.get(_.find(_.get(model, 'kommunikationsmedien'), ['art.wert', 'EMAILP']), 'wert');
            }

            return value;
        }
        function setResultsUrls(angebot) {
            var IntegrationService = $injector.get('IntegrationService'),
                angebotsnummer = BasisAngebotService.getAngebotsnummer(angebot),
                provider = _.toLower(_.get(angebot, 'zahlungsinformationen.inkassoart')),
                token = BasisAngebotService.getToken(angebot),
                paymentProviderConfig = AppConfig.ANGEBOT.paymentProvider[isAsyncAlternativeBezahlmethode(angebot) && DeviceUtilsService.supportsPopups() ? 'popup' : 'redirect'],
                urlPrefix = MiscUtilsService.getAbsoluteUrl(paymentProviderConfig.urlPrefix),
                subtyp = IntegrationService.getIntegrationParams().subtyp;
            _.set(angebot, 'zahlungsinformationen.bezahldienstleisterDaten.resultUrlSuccess', urlPrefix + FormatUtilsService.replace(paymentProviderConfig.resultUrlSuccess, subtyp, angebotsnummer, token, provider));
            _.set(angebot, 'zahlungsinformationen.bezahldienstleisterDaten.resultUrlFailure', urlPrefix + FormatUtilsService.replace(paymentProviderConfig.resultUrlFailure, subtyp, angebotsnummer, token, provider));
        }
        function isPayPal(angebot) {
            var inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart'),
                inkassoartPayPal = BasisAngebotService.getConstant('inkassoarten').paypal || {};

            return inkassoart === inkassoartPayPal.wert;
        }
        function isSofortueberweisung(angebot) {
            var inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart'),
                inkassoartSofortueberweisung = BasisAngebotService.getConstant('inkassoarten').sofortueberweisung || {};

            return inkassoart === inkassoartSofortueberweisung.wert;
        }
        function isDirektueberweisung(angebot) {
            var inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart'),
                inkassoartDirektueberweisung = BasisAngebotService.getConstant('inkassoarten').direktueberweisung || {};

            return inkassoart === inkassoartDirektueberweisung.wert;
        }
        function isKreditkarte(angebot) {
            var inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart'),
                inkassoartKreditkarte = BasisAngebotService.getConstant('inkassoarten').kreditkarte || {};

            return inkassoart === inkassoartKreditkarte.wert;
        }
        function isAsyncAlternativeBezahlmethode(angebot) {
            return (
                isPayPal(angebot) ||
                isSofortueberweisung(angebot) ||
                isDirektueberweisung(angebot)
            );
        }
        function isAlternativeBezahlmethode(angebot) {
            var inkassoarten = BasisAngebotService.getConstant('inkassoarten') || {},
                inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart');

            return _.includes([
                inkassoarten.kreditkarte.wert, // Kreditkarte
                inkassoarten.paypal.wert, // PayPal
                inkassoarten.sofortueberweisung.wert, // Sofortüberweisung
                inkassoarten.direktueberweisung.wert
            ], inkassoart);
        }
    }
})();
